import React from 'react';
import zhCN from 'antd/es/locale-provider/zh_CN'; // antd的中文包
import { HashRouter } from 'react-router-dom';
import { MyRouter } from './router/router'; // 刚才的router.tsx
import { ConfigProvider, message, notification } from 'antd';
// import storeConfig from './store'; // redux的仓库
import moment  from 'moment'; // momentjs。
import 'moment/locale/zh-cn'; // 中文包moment.js
import 'antd/dist/antd.less';
import './pages/css/App.less'
//import Login from "./pages/login";
import store from "store";
import AxiosUtil from "./utils/AxiosUtil";
moment.locale('zh-cn'); // 将moment.js设置为中文

// const store = storeConfig(); // 初始化redux的store，如不需要状态管理器，redux相关可以忽略。

message.config({ // antd的message组件配置，during持续时间单位为秒，maxcount最多显示个数
    duration: 2,
    maxCount: 2
});
notification.config({
    placement: 'topRight', // antd的通知组件配置，placement弹出位置。bottom距离底部的距离，during持续时间单位为秒
    bottom: 50,
    duration: 2,
});

function App() {

    const login_info = store.get('login_info');
    //console.log("login_info",login_info);
    const menuListCallback = (suc: boolean, d?: any) => {
        if (suc) {
            const menus = d.list;
            store.set('login_power', menus);
        }else{
            window.location.replace('/#/login');
        }
    }
    if (login_info && login_info.user_id) {
        AxiosUtil.AxiosRequest('/api/menu/menuList', {user_id: login_info.user_id}, menuListCallback);
    }else{
        window.location.replace('/#/login');
    }

    return (
        <ConfigProvider locale={zhCN}>
            <HashRouter>
                <MyRouter/>
            </HashRouter>
        </ConfigProvider>
    );
}

export default App;